import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, CardContent, TextField } from '@mui/material';
import { SimpleMenu } from 'components';
import { useEvents } from 'hooks';

const IrrigateFieldInput = () => {
  const { t } = useTranslation();
  const { setPlan, farmerPlan } = useEvents();

  const handleAmountChange = (event) => {
    setPlan({ data: { ...farmerPlan.data, irrigation_amount: event.target.value } });
  };

  const handleIrrigationUnitsChange = (units) => {
    setPlan({ data: { ...farmerPlan.data, irrigation_units: units } });
  };

  return (
    <div>
      <CardContent>
        <Typography variant="h6">{t('irrigation_information')}</Typography>
      </CardContent>
      <Grid container>
        <Grid item container direction="row" alignItems="center" xs={12} sm={8} padding={2}>
          <Grid item>
            <TextField
              id="irrigation_amount"
              label={t('irrigation_amount')}
              value={farmerPlan?.data?.irrigation_amount}
              placeholder="0"
              onChange={handleAmountChange}
              type="number"
            />
          </Grid>
          <Grid item>
            <SimpleMenu
              placeholder={t('irrigation_units')}
              menuItems={[t('gallons'), t('acre_inches')]}
              selectedItem={farmerPlan?.data?.irrigation_units}
              selectItem={handleIrrigationUnitsChange}
              size="normal"
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default IrrigateFieldInput;
